var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTip = function SvgIconTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#91A3AD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.84 8.366h1.116c.072 0 .12-.048.12-.12v-.348c0-.36.06-.528.24-.756l.948-1.296c.336-.444.492-.888.492-1.404 0-1.224-.936-2.088-2.256-2.088s-2.184.744-2.376 1.944c-.012.072.012.132.096.144l1.08.168c.072.012.12-.024.132-.096.108-.612.456-.96 1.02-.96.576 0 .936.384.936.9 0 .324-.12.6-.408.984l-.948 1.296c-.216.3-.312.54-.312 1.02v.492c0 .072.048.12.12.12m-.168 2.16c0 .072.048.12.12.12h1.2c.072 0 .12-.048.12-.12V9.302c0-.072-.048-.12-.12-.12h-1.2c-.072 0-.12.048-.12.12z"
  }))));
};
export default SvgIconTip;